module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG1001-a30b548f601367b4e3e4285db285b159.png";